var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifications),function(notification,index){return _c('alert',{key:index,attrs:{"level":notification.level,"title":_vm.$t(notification.title)}},[(notification.body)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(notification.body))}}):_vm._e()])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }